import styled, { css } from 'styled-components'

const withNotActiveMixin = css`
  height: .875rem;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  transition: background .3s ease-in-out;
`

const Main = styled.div`
  min-height: 1.25rem;
  height: ${props => (props.visible ? props.maxHeight : props.minHeight)};
  margin-bottom: .5rem;
  overflow: hidden;

  transition: height .5s ease-in-out;
  will-change: height;
  position: relative;

  &::after {
    bottom: 0;
    content: ' ';
    position: absolute;

    width: 100%;

    ${props => !props.visible && props.isButtonVisible && withNotActiveMixin}
  }
`

const Button = styled.button(
  ({ theme }) => `
    display: flex;
    align-self: flex-start;
    align-items: flex-center;
    justify-content: space-between;

    padding: 0;

    font-size: .875rem;
    font-weight: ${theme.font.weight.semibold};
    outline: transparent;

    &:hover {
      cursor: pointer;
      color: ${theme.colors.success};
      transition: color 300ms cubic-bezier(.19, 1, .22, 1);
    }
  `
)

const Glyph = styled.i`
  font-size: .75rem;

  transition: transform 300ms cubic-bezier(.47, .01, 1, 1);
  transition-delay: 300ms;
  transform: ${props => (props.active ? 'rotate(-90deg)' : 'rotate(90deg)')};
`

const Span = styled.span`
  display: flex;

  margin-right: .625rem;
`

export { Main, Button, Glyph, Span }
